module.exports = __webpack_public_path__ + "img/chart-line-multi.5abad131.svg";